
export const ACTION_REMOVE_MOD = "Удалить мод"

export const ACTION_REMOVE_DRAFT = "Удалить"
